/*
 * pdp-footer.js
 * ---------------------------------------------------------------
 * Collapses the footer's link columns on a phone.
 *
 * They were headings with a list underneath, always open. Stacked into
 * one column that is a long scroll of links, and -- more to the point --
 * a heading that does nothing looks the same as a heading that does, so
 * there was nothing telling anyone the sections were even groupable.
 *
 * The indicator only appears once the behaviour does. An affordance on
 * something that is not tappable is worse than no affordance: it
 * promises an interaction the page cannot honour. So the toggle is
 * built at mobile widths and taken apart again on desktop, where the
 * columns sit side by side and being open is correct.
 *
 * Progressive enhancement: with no JavaScript the columns render open,
 * which is the state they were in before.
 * ---------------------------------------------------------------
 */

(function () {
  'use strict';

  var QUERY = '(max-width: 749px)';
  var CHEVRON =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"' +
    ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
    '<path d="m6 9.5 6 6 6-6"/></svg>';

  function collapse(block, index) {
    if (block.dataset.ftAccordion === 'true') return;

    var heading = block.querySelector('.footer-block__heading');
    var list = block.querySelector('.footer-block__details-content');
    if (!heading || !list) return;

    var id = 'footer-menu-' + index;
    list.id = list.id || id;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'footer-block__toggle';
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-controls', list.id);
    button.innerHTML =
      '<span class="footer-block__toggle-text">' + heading.innerHTML + '</span>' +
      '<span class="footer-block__toggle-icon">' + CHEVRON + '</span>';

    heading.innerHTML = '';
    heading.appendChild(button);
    heading.classList.add('footer-block__heading--toggle');

    list.hidden = true;
    block.dataset.ftAccordion = 'true';

    button.addEventListener('click', function () {
      var open = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', String(!open));
      list.hidden = open;
    });
  }

  function expand(block) {
    if (block.dataset.ftAccordion !== 'true') return;

    var heading = block.querySelector('.footer-block__heading');
    var list = block.querySelector('.footer-block__details-content');
    var text = block.querySelector('.footer-block__toggle-text');
    if (!heading || !list) return;

    // The heading goes back to being a heading, with its own words.
    if (text) heading.innerHTML = text.innerHTML;
    heading.classList.remove('footer-block__heading--toggle');
    list.hidden = false;
    delete block.dataset.ftAccordion;
  }

  function apply() {
    var small = window.matchMedia(QUERY).matches;
    document.querySelectorAll('.footer-block--menu').forEach(function (block, i) {
      if (small) {
        collapse(block, i);
      } else {
        expand(block);
      }
    });
  }

  function init() {
    apply();

    var mq = window.matchMedia(QUERY);
    if (mq.addEventListener) {
      mq.addEventListener('change', apply);
    } else if (mq.addListener) {
      mq.addListener(apply);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', apply);
})();
